@if (quoteRequestForm !== undefined) {
  <div [formGroup]="requestDetailsGroup" class="cipx-form-section">
    <fieldset>
      <legend class="cipx-form-section-title">
        {{ getSectionTitle() }}
      </legend>

      <div formArrayName="owners">
        <div *ngFor="let owner of owners.controls; let i = index" [formGroupName]="i">
          @if ((quoteRequestForm.controls.requestDetails.controls.company_number_owners.value ?? 1) > 1 && i >= 1) {
            <hr />
          }
          @if ((quoteRequestForm.controls.requestDetails.controls.company_number_owners.value ?? 1) > 1) {
            <label class="text-lg">Owner {{ i + 1 }}</label>
          }
          <div class="mt-2">
            <label class="cipx-form-label">Applicant Name</label>
          </div>
          <div class="flex sm:flex-row flex-col">
            <mat-form-field class="w-full" [hideRequiredMarker]="true" subscriptSizing="dynamic">
              <input matInput type="text" formControlName="owner_first_name" placeholder="First Name" />
            </mat-form-field>
            <mat-form-field class="w-full sm:mx-4 my-4 sm:my-0" [hideRequiredMarker]="true" subscriptSizing="dynamic">
              <input matInput type="text" formControlName="owner_middle_name" placeholder="Middle Name" />
            </mat-form-field>
            <mat-form-field class="w-full mb-4 sm:mb-0" [hideRequiredMarker]="true" subscriptSizing="dynamic">
              <input matInput type="text" formControlName="owner_last_name" placeholder="Last" />
            </mat-form-field>
          </div>

          <sbd-app-address-form
            prefix="owner_"
            [formGroup]="getOwnerGroup(i)"
            [showCounty]="false"></sbd-app-address-form>

          <div class="cipx-form-form-group">
            <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
              <mat-label>How many years of industry experience?</mat-label>
              <input matInput type="number" formControlName="owner_years_experience" placeholder="Years Experience" />
            </mat-form-field>

            @if ((quoteRequestForm.controls.requestDetails.controls.company_number_owners.value ?? 1) > 1) {
              <div class="cipx-form-form-group">
                <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
                  <mat-label>What percent ownership of the company does this person have?</mat-label>
                  <input matInput type="number" formControlName="owner_percent_owned" placeholder="Years Experience" />
                </mat-form-field>
              </div>
            }
            @if (
              selectedStateBond() !== null &&
              selectedStateBond() &&
              isCIPXQuoteRequestIntakeFormStateBond(selectedStateBond()!) &&
              requiresCredit(selectedStateBond()!)
            ) {
              <div class="cipx-form-form-group flex flex-row items-center">
                <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
                  <mat-label>Social security number</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="owner_ssn"
                    placeholder="999-99-9999"
                    [mask]="'999-99-9999'" />
                </mat-form-field>
                <mat-icon
                  class="ml-2"
                  matTooltip="This data is encrypted using bank-level encryption technology."
                  svgIcon="heroicons_outline:lock-closed"></mat-icon>
              </div>
            }
            <div class="cipx-form-form-group flex flex-row items-center">
              <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
                <mat-label>Email Address</mat-label>
                <input matInput type="text" formControlName="owner_email" placeholder="Email Address" />
                @if (getOwnerGroup(i).get('owner_email')?.hasError('teamMemberEmail')) {
                  <mat-error>This email belongs to a team member and cannot be used as an owner email.</mat-error>
                }
                <mat-hint>
                  If you add email addresses for the owners or other contacts, they will not be notified, but it may
                  save time if their signatures are required.
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="space-y-4">
      <sbd-app-address-form
        prefix="company_"
        [formGroup]="principal"></sbd-app-address-form>
    </div> -->
    </fieldset>
  </div>
}
